import React, { useEffect, useState } from 'react';
const roboman_api = process.env.REACT_APP_ROBOMAN_API;

// --- ICONS ---
const EyeIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
);

const EyeOffIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
);

const SpinnerIcon = ({ className }) => (
    <svg className={`animate-spin ${className}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);


// --- REUSABLE UI COMPONENTS ---
const SectionCard = ({ children, title, subtitle }) => (
    <div className="p-4 sm:p-8 min-h-screen">
    <div className='max-w-4xl mx-auto' >
        <h2 className="text-xl md:text-2xl font-extrabold font-Inter opacity-1 bg-gradient-to-r from-gray-700 via-blue-700 to-fuchsia-700  bg-clip-text text-transparent">{title}</h2>
        <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
        <div className="mt-6">{children}</div>
    </div>
    </div>
);
const Card = ({ children, className }) => (
    <div className={`bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-lg border border-white/50 ${className}`}>
        {children}
    </div>
);
const Notification = ({ message, type }) => {
    if (!message) return null;
    const styles = {
        error: "bg-red-100 border-red-300 text-red-800",
        success: "bg-green-100 border-green-300 text-green-800"
    };
    return (
        <div className={`p-4 rounded-lg text-sm font-medium border ${styles[type]}`}>
            {message}
        </div>
    );
};

// --- MAIN COMPONENT ---
const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(true)

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');



    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // Basic Validation
        if (!newPassword || !confirmPassword) {
            setError("All fields are required.");
            return;
        }
        if (newPassword.length < 8) {
            setError("New password must be at least 8 characters long.");
            return;
        }
        if (newPassword !== confirmPassword) {
            setError("New passwords do not match.");
            return;
        }
        setLoading(true);


        try {
            const access_token = localStorage.getItem("access_token")
            const response = await fetch(`${roboman_api}/users/me/password/change`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": access_token
                },
                body: JSON.stringify({
                    new_password: newPassword,
                    confirm_password: confirmPassword,
                }),
            });
            const data = await response.json();

            console.log(data.msg);

            if (!response.ok) {
                throw new Error(data.detail?.[0]?.msg || "Password update failed");
            }

            setSuccess(data.msg);
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            setError(err.message)
        }
        finally {
            setLoading(false);
        }


        // --- Mock API Call ---
        // In a real app, you would make a network request here.

        // setTimeout(() => {
        //     // Simulate a success scenario
        //     if (currentPassword === "password123") { // Mock check for correct current password
        //         setSuccess("Your password has been updated successfully!");
        //         setCurrentPassword('');
        //         setNewPassword('');
        //         setConfirmPassword('');
        //     } else {
        //         // Simulate an error scenario
        //         setError("The current password you entered is incorrect.");
        //     }
        //     setLoading(false);
        // }, 1500);
    };

    return (
        <SectionCard
            title="Change Password"
            subtitle="For your security, we recommend using a strong, unique password that you don't use for other services."
        >
            <Card>
                <form onSubmit={handleSubmit}>
                    <h3 className="text-lg font-semibold text-slate-800">Update Your Password</h3>

                    <div className="mt-6 space-y-5 max-w-md">
                        {/* Current Password Field */}
                        {/* <div>
                            <label htmlFor="currentPassword" className="block text-sm font-medium text-slate-700">
                                Current Password
                            </label>
                            <div className="relative mt-1">
                                <input
                                    type={showCurrent ? "text" : "password"}
                                    id="currentPassword"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    className="block w-full px-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                                <button type="button" onClick={() => setShowCurrent(!showCurrent)} className="absolute inset-y-0 right-0 px-3 flex items-center text-slate-500 hover:text-slate-700">
                                    {showCurrent ? <EyeOffIcon className="w-5 h-5"/> : <EyeIcon className="w-5 h-5"/>}
                                </button>
                            </div> 
                        </div> */}

                        {/* New Password Field */}
                        <div>
                            <label htmlFor="newPassword" className="block text-sm font-medium text-slate-700">
                                New Password
                            </label>
                            <div className="relative mt-1">
                                <input
                                    type={showNew ? "text" : "password"}
                                    id="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    className="block w-full px-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                                <button type="button" onClick={() => setShowNew(!showNew)} className="absolute inset-y-0 right-0 px-3 flex items-center text-slate-500 hover:text-slate-700">
                                    {showNew ? <EyeOffIcon className="w-5 h-5" /> : <EyeIcon className="w-5 h-5" />}
                                </button>
                            </div>
                        </div>

                        {/* Confirm New Password Field */}
                        <div>
                            <label htmlFor="confirmPassword" className="block text-sm font-medium text-slate-700">
                                Confirm New Password
                            </label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="mt-1 block w-full px-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>

                        {/* Password Requirements */}
                        <div className="text-xs text-slate-500 pl-1">
                            <p className="font-medium text-slate-600">Password must contain:</p>
                            <ul className="list-disc list-inside mt-1 space-y-1 text-left">
                                <li>At least 8 characters</li>
                                <li>A mix of uppercase and lowercase letters</li>
                                <li>At least one number or symbol</li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-8 pt-6 border-t border-slate-200 space-y-4">
                        {/* Notification Area */}
                        <Notification message={error} type="error" />
                        <Notification message={success} type="success" />

                        {/* Action Buttons */}
                        <div className="flex flex-col md:flex-row justify-end items-center gap-4 ">
                            <a href="#" className="text-sm font-thin  text-blue-600 hover:underline order-2 md:order-1">
                                Forgot your password?
                            </a>
                            <button
                                type="submit"
                                disabled={loading}
                                className="order-1 md:order-2 bg-gradient-to-r from-indigo-600 via-violet-600 to to-pink-600 text-white font-semibold md:py-2 md:px-7 py-2 px-12 rounded-lg hover:bg-blue-700 transition-colors shadow-md flex items-center justify-center disabled:bg-slate-400 disabled:cursor-not-allowed"
                            >
                                {loading && <SpinnerIcon className="w-5 h-5 mr-2" />}
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                        </div>
                    </div>
                </form>
            </Card>
        </SectionCard>
    );
};

export default ChangePassword;